import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from '../slices/staffSlice';
import { fetchRequests } from '../Requests/getRequests';
import { show } from '../slices/toastSlice';
import { authStaff } from '../utils/constants';
import { useNavigate } from 'react-router-dom';

// Fetches the latest mandate status from ITC for a given third-party reference number
function useNpontuMandateStatus({ ref }) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const accessToken = useSelector(selectAccessToken);
    const [isLoading, setIsLoading] = useState(true);
    const [mandateStatus, setMandateStatus] = useState(null);

    useEffect(() => {
        if (!ref) return;

        let unsubscribed = false;

        const getMandateStatus = async() => {
            setIsLoading(true);

            let headers = authStaff(accessToken);
            let url = `/payments/npontu/mandate/status`;
            let params = { ref };

            let res = await fetchRequests(url, "GET", headers, params, {});
            setIsLoading(false);

            if(res?.code === 401){
                sessionStorage.clear();
                navigate("/login");
                dispatch(show({
                    type : "error",
                    state : true,
                    message : "Your session has expired. Please login to continue."
                }));
                return;
            }

            if(res?.err){
                dispatch(show({
                    type : "error",
                    state : true,
                    message : res?.err
                }));
                return;
            }

            if(!unsubscribed){
                setMandateStatus(res?.data?.data ?? null);
            }
        }

        getMandateStatus();

        return () => {
            unsubscribed = true;
        }
    }, [dispatch, navigate, accessToken, ref])

    return { isLoading, mandateStatus }
}

export default useNpontuMandateStatus
